'use client';

import { forwardRef, ChangeEvent } from 'react';
import styles from './text-field-comment.module.scss';
import { TextFieldCommentType } from '@/types/contactsBlock.types';

const TextFieldComment = forwardRef<HTMLTextAreaElement, TextFieldCommentType>(
  ({ className = '', value = '', onChange, error }, ref) => {
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(e.target.value);
    };

    return (
      <div className={[styles.textField, className].join(' ')}>
        <div className={styles.label}>Your message</div>
        <textarea
          ref={ref}
          className={[styles.row, error ? styles.error : ''].join(' ')}
          placeholder="Enter your message (any questions or wishes)"
          rows={4}
          cols={26}
          value={value}
          onChange={handleChange}
        />
        {error && <div className={styles.errorText}>{error}</div>}
      </div>
    );
  }
);

TextFieldComment.displayName = 'TextFieldComment';

export default TextFieldComment;
